// Título, descrição e dados estruturados da home. Sem imports de React:
// também é usado por scripts/prerender-seo.mjs no build.
import { SITE_URL } from "./landingPages.js";

const siteUrl = SITE_URL;
export const canonicalUrl = `${siteUrl}/`;
export const logoUrl = `${siteUrl}/assets/logo/SETTE-FIBRA2.png`;
export const pageTitle =
  "Internet Fibra Óptica em Anápolis | SETTE Fibra - Planos Rápidos e Estáveis";
export const pageDescription =
  "A internet fibra óptica mais bem avaliada de Anápolis. Alta velocidade, estabilidade e suporte local 24h. Planos residenciais e empresariais da Sette Fibra. Fale no WhatsApp e contrate com quem é recomendado.";
export const schemaLocalBusiness = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": `${siteUrl}/#organization`,
  additionalType: "https://schema.org/InternetServiceProvider",
  name: "Sette Fibra",
  url: siteUrl,
  image: logoUrl,
  logo: logoUrl,
  description: pageDescription,
  slogan: "Uma fibra. Sette possibilidades.",
  telephone: "+55 62 4051-9377",
  email: "info@settefibra.com.br",
  taxID: "12.041.618/0001-89",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Rua Waldomiro Correia Neto, 956 Jardim Alexandrina",
    addressLocality: "Anápolis",
    addressRegion: "GO",
    postalCode: "75060-473",
    addressCountry: "BR",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: -16.294718977110477,
    longitude: -48.95818865523164,
  },
  areaServed: {
    "@type": "City",
    name: "Anápolis",
  },
  contactPoint: [
    {
      "@type": "ContactPoint",
      telephone: "+55 62 4051-9377",
      contactType: "customer service",
      areaServed: "BR",
      availableLanguage: ["pt-BR"],
    },
  ],
  sameAs: [
    "https://www.instagram.com/settefibra/",
    "https://www.facebook.com/SETTEFIBRA/",
    "https://www.linkedin.com/company/sette-fibra/",
    "https://www.tiktok.com/@settefibra",
  ],
};
export const schemaWebsite = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${siteUrl}/#website`,
  url: siteUrl,
  name: "Sette Fibra",
  publisher: { "@id": `${siteUrl}/#organization` },
};
export const schemaWebPage = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "@id": `${siteUrl}/#webpage`,
  url: canonicalUrl,
  name: pageTitle,
  description: pageDescription,
  inLanguage: "pt-BR",
  isPartOf: { "@id": `${siteUrl}/#website` },
  about: { "@id": `${siteUrl}/#organization` },
  primaryImageOfPage: {
    "@type": "ImageObject",
    url: logoUrl,
  },
};
